import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

export const DEFAULT_LANGUAGE = 'hu';

const s3 = `https://cx-ray-locales-01.s3.eu-central-1.amazonaws.com`;
const bucket = `employee-ui`;

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    detection: {
      order: [ 'querystring', 'localStorage', 'navigator' ],
      lookupQuerystring: 'language',
      lookupLocalStorage: 'i18nextLng'
    },
    backend: {
      loadPath: `${s3}/${bucket}/{{lng}}/{{ns}}.json`
    },
    fallbackLng: (DEFAULT_LANGUAGE || '').toLowerCase(),
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    react: { useSuspense: true }
  });

export default i18n;
